import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { NumberInput, CommonInputProps } from "react-admin";
import TextField from "@mui/material/TextField";
import { useFormContext } from "react-hook-form";
import lodashGet from "lodash/get";
import { RangeOutlineBox } from "../common/RangeOutlineBox";

export const NumberRangeInput = (props: NumberRangeInputProps) => {
  const { label, source, alwaysOn, ...rest } = props;

  const form = useFormContext();
  const filterValues = form.getValues();

  useEffect(() => {
    let filterValue = lodashGet(filterValues, source);

    if (
      typeof filterValue !== "undefined" &&
      filterValue != "" &&
      !Object.values(filterValue).some((v) => v)
    ) {
      form.setValue(source, "");
    }
  }, [filterValues]);

  const handleChange = (e) => {
    let { id, value } = e.target;
    let filterValue = lodashGet(filterValues, source);

    if (typeof filterValue === "undefined" || filterValue == "") {
      filterValue = {};
    }

    if (value == "") {
      delete filterValue[id];

      if (Object.keys(filterValue).length === 0) {
        filterValue = "";
      }
    } else {
      filterValue[id] = value;
    }

    form.setValue(source, filterValue);
  };

  return (
    <React.Fragment>
      <RangeOutlineBox label={label}>
        <TextField
          id="from"
          type="number"
          label={":from"}
          sx={{ width: "5em" }}
          variant="outlined"
          onChange={handleChange}
          {...rest}
        />
        <div className="rangeInputSpacer">&nbsp;</div>
        <TextField
          id="to"
          type="number"
          label={":to"}
          sx={{ width: "5em" }}
          variant="outlined"
          onChange={handleChange}
          {...rest}
        />
      </RangeOutlineBox>
    </React.Fragment>
  );
};

NumberRangeInput.propTypes = {
  filter: PropTypes.object,
  label: PropTypes.string,
  source: PropTypes.string,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export type NumberRangeInputProps = CommonInputProps & {
  label: string;
  source: string;
  step?: string | number;
  min?: string | number;
  max?: string | number;
};
